import store from '@/store'; // Importiere den Vuex-Store
import { getXmlValueFE } from '@/utils/getXmlValueFE';

export function replaceTextinRule(text, rules){
    const ruleset = rules.filter(r => r.replacedText == text);
    let newText
    ruleset.forEach(rule => {
      const statement = rule.statement
      const xPath = (statement) ? store.state.xPathPlaceholders.find(p => p.placeholder === statement)?.xpath : null
      const dataStatementValue = getXmlValueFE(xPath) //value of key "statement" in example customer data
      const value = rule.value
      const operator = rule.operator
      switch (operator){
          case '==':
          case '=': //in case of user mistake
            if (dataStatementValue == value) {
              newText = rule.text
            }
            break;
          case '<':
            if (dataStatementValue < value) {
              newText = rule.text
            }
            break;
          case '>':
            if (dataStatementValue > value) {
              newText = rule.text
            }
            break;
          case '!=':
            if (dataStatementValue !== value) {
              newText = rule.text
            }
            break;
      }
    }
    )
    return newText
  }